import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import * as yup from "yup";

// material-ui
import { Button, Grid, MenuItem, TextField, Typography } from "@mui/material";

// form
import { Controller, FormProvider, useForm } from "react-hook-form";

// project imports
import { TextInput } from "qubCommon/Inputs";

// Apis

import {
  impersonate,
  selectFunctionForImpersonation,
} from "apis/controllers/admin";
import { useYupValidationResolver } from "hooks/useYupValidationResolver";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { login } from "store/authReducer";
import { storeMenu } from "store/menuReducer";
import {
  getSelectedProgramDataKey,
  setSelectedProgramDataKey,
} from "util/programSelection";
import SelectRoleDialog from "./SelectRoleDialog";

const defaultValues = {
  username: "",
  afm: "",
  programDataKey: getSelectedProgramDataKey() || "program6",
};

const Impersonation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [roles, setRoles] = useState([]);
  const [selectRoleDialogOpen, setSelectRoleDialogOpen] = useState(false);

  const resolver = useYupValidationResolver(
    yup.object({
      // username: yup.string().max(255).required("Το πεδίο είναι υποχρεωτικό"),
    })
  );
  const { t } = useTranslation();
  const methods = useForm({
    resolver,
    defaultValues,
    mode: "onSubmit",
    reValidateMode: "onBlur",
  });
  const { enqueueSnackbar } = useSnackbar();
  const onSubmit = async (data) => {
    if (data?.username) {
      await selectFunctionForImpersonation({
        afm: data?.afm,
        username: data?.username,
      })
        .then((res) => {
          console.log(res);
          if (res?.data?.urpfs?.length > 0) {
            setRoles(res?.data?.urpfs);
            setSelectRoleDialogOpen(true);
          }
        })
        .catch((err) => {
          console.log(err);
          enqueueSnackbar(err?.message || err || "Παρουσιάστηκε Σφάλμα", {
            variant: "error",
          });
        });
    } else {
      await impersonate({
        afm: data.afm,
      })
        .then((res) => {
          setSelectedProgramDataKey(data.programDataKey);
          enqueueSnackbar(`Επιτυχής σύνδεση`, {
            variant: "success",
          });
          dispatch(storeMenu(res?.menu));
          dispatch(
            login({
              token: res?.token,
              refreshToken: res?.refreshToken,
              user: res?.user,
              seasonId: res?.season
            })
          );
          navigate("/home");
        })
        .catch((error) => {
          enqueueSnackbar(error || t("SomethingWrong"), {
            variant: "error",
          });
        });
    }
  };

  return (
    <Grid container sx={{ minHeight: "70vh", padding: 4 }}>
      <FormProvider {...methods}>
        <SelectRoleDialog
          open={selectRoleDialogOpen}
          onClose={() => setSelectRoleDialogOpen(false)}
          roles={roles}
        />
        <form>
          <Grid
            container
            direction="column"
            justifyContent="center"
            spacing={2}
            sx={{
              borderRadius: 4,
              bgcolor: "#f3f3f3",
              padding: 4,
              minWidth: "600px",
            }}
          >
            <Grid item xs={12}>
              <Typography variant="h4" align="center" mb={4}>
                Impersonation
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextInput id="afm" name="afm" placeholder="ΑΦΜ" size="medium" />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="programDataKey"
                control={methods.control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    fullWidth
                    size="medium"
                    label="Πρόγραμμα πολίτη"
                    helperText="Χρησιμοποιείται στο impersonation με ΑΦΜ."
                  >
                    <MenuItem value="program5">Πρόγραμμα 5</MenuItem>
                    <MenuItem value="program6">Πρόγραμμα 6</MenuItem>
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <TextInput
                id="username"
                name="username"
                placeholder={t("Username")}
                size="medium"
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                disabled={methods.formState.isSubmitting}
                fullWidth
                size="large"
                variant="contained"
                type="submit"
                onClick={methods.handleSubmit(onSubmit)}
              >
                {t("Submit")}
              </Button>
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </Grid>
  );
};

export default Impersonation;
